import { ExistingFirmResponse } from 'api/firm/firm.types';

export const STRIDEUP_INTERNAL_FIRM_NAME = 'StrideUp Internal';
export const STRIDEUP_INTERNAL_FIRM_FCA_NUMBER = '785299';

export function isStrideUpInternalFirm(firm: ExistingFirmResponse | null | undefined): boolean {
  if (!firm) {
    return false;
  }

  return firm.name === STRIDEUP_INTERNAL_FIRM_NAME && firm.fcaNumber === STRIDEUP_INTERNAL_FIRM_FCA_NUMBER;
}
